import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/trip-update',
            name: 'admin-trip-update',
            component: () => import(/* webpackChunkName: "page-admin-trip-management-trip-update" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "批量更新"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "行程单管理"
                                        },
                                        {
                                                  name: "批量更新"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
